import { Component, h, Listen, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { Trackable } from '../../types/global';

export interface SocialLink extends Trackable {
  socialNetwork: 'blog' | 'facebook' | 'linkedin' | 'twitter' | 'xing' | 'youtube' | 'whatsapp';
  href: string;
  mouseover: string;
}
interface UiCmsSocialFollowLinksBody {
  text: string;
  links: SocialLink[];
  position: 'left' | 'right';
}

@Component({
  tag: 'ui-cms-social-follow-links',
  styleUrl: 'ui-cms-social-follow-links.css',
})
export class UiCmsSocialFollowLinks {
  @Prop({ mutable: true }) body: UiCmsSocialFollowLinksBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Listen('linkClick')
  linkClickHandler(event: CustomEvent<{ link: SocialLink }>) {
    const { link } = event.detail;

    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Click Social Network Icon',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Link',
        elementLabel: link.socialNetwork || '',
        externalTarget: link.href || '',
      },
      category: {
        area: 'Footer',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  render() {
    return (
      <ui-social-follow-links
        text={this.body.text}
        links={this.body.links || []}
        position={this.body.position}
      ></ui-social-follow-links>
    );
  }
}
